const STATUS_CODE_RESPONSE = {
  SUCCESS: '00',
};

const MESSAGE_TYPE = {
  CLEAR_ERRORS: 'clearErrors',
  COMPLETE_PAYMENT: 'completePayment',
  HANDLE_TRANSACTION_ERRORS: 'handleTransactionErrors',
  INIT: 'init',
  START_PAYMENT: 'startPayment',
};

const PAYMENT_TYPE = {
  ACH: 1,
  CREDIT_CARD: 2,
};

export {
  MESSAGE_TYPE,
  PAYMENT_TYPE,
  STATUS_CODE_RESPONSE,
};
